import { useState } from 'react';
import {
  DateRange,
  getDateRangeFromStorage,
  setDateRangeToStorage,
} from 'src/components/selfService/features/OrderHistory/OrderHistory.utils';

export interface UseDateRangeProps {
  corpId: string;
}
export interface UseDateRange extends DateRange {
  setDateRange: (range: DateRange) => void;
}

export const useDateRange = ({ corpId }: UseDateRangeProps): UseDateRange => {
  const dateRange = getDateRangeFromStorage(corpId);

  const [startDate, setStartDate] = useState(dateRange.startDate);
  const [endDate, setEndDate] = useState(dateRange.endDate);

  function setDateRange({
    startDate: newStartDate,
    endDate: newEndDate,
  }: DateRange) {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    setDateRangeToStorage(corpId, {
      startDate: newStartDate,
      endDate: newEndDate,
    });
  }

  return {
    setDateRange,
    startDate,
    endDate,
  };
};
